<app-modal-shell [title]="title" size="lg" [closeDisabled]="saving" (closed)="close()">
  <div icon class="header-icon">
    <i class="bi" [class]="headerIcon"></i>
  </div>

  @if (loading) {
    <div class="loading-panel">
      <app-loader />
    </div>
  } @else {
    <div class="wizard-steps">
      <div class="wizard-step" [class.active]="step === 'select'" [class.done]="step === 'form'">
        <span class="step-index">1</span>
        <span class="step-label">Choose Database</span>
      </div>
      <div class="wizard-divider"></div>
      <div class="wizard-step" [class.active]="step === 'form'">
        <span class="step-index">2</span>
        <span class="step-label">Credentials</span>
      </div>
    </div>

    @if (step === 'select') {
      <div class="db-option-grid" [class.disabled]="switchingType">
        @for (option of dbOptions; track option.type) {
          <button
            type="button"
            class="db-option-card"
            [class.active]="selectedType === option.type"
            [disabled]="switchingType"
            (click)="selectType(option.type)"
          >
            @if (switchingType && selectedType === option.type) {
              <span class="db-option-spinner spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            } @else {
              <div class="db-option-icon">
                <i class="bi" [class]="option.icon"></i>
              </div>
            }
            <div class="db-option-label">{{ option.label }}</div>
            <div class="db-option-desc">{{ option.description }}</div>
          </button>
        }
      </div>
    } @else if (form) {
      <form [formGroup]="form" class="db-form">
        <button type="button" class="change-type-link" (click)="changeType()">
          <i class="bi bi-arrow-left"></i>
          <span>Change database type</span>
        </button>

        @switch (selectedType) {
          @case ('MSSQL') {
            <div class="form-section">
              <h6 class="section-title">Connection</h6>
              <div class="form-row">
                <div class="form-group">
                  <label for="synapse_server">Server</label>
                  <input id="synapse_server" type="text" formControlName="synapse_server" placeholder="myserver.sql.azuresynapse.net" />
                  @if (form.controls['synapse_server'].invalid && form.controls['synapse_server'].touched) {
                    <span class="field-error">Server is required.</span>
                  }
                </div>
                <div class="form-group">
                  <label for="synapse_db">Database</label>
                  <input id="synapse_db" type="text" formControlName="synapse_db" placeholder="mydb" />
                  @if (form.controls['synapse_db'].invalid && form.controls['synapse_db'].touched) {
                    <span class="field-error">Database is required.</span>
                  }
                </div>
              </div>
              <div class="form-row">
                <div class="form-group">
                  <label for="synapse_user">Username</label>
                  <input id="synapse_user" type="text" formControlName="synapse_user" placeholder="readuser" />
                  @if (form.controls['synapse_user'].invalid && form.controls['synapse_user'].touched) {
                    <span class="field-error">Username is required.</span>
                  }
                </div>
                <div class="form-group">
                  <label for="synapse_password">Password</label>
                  <div class="input-with-action">
                    <input id="synapse_password" [type]="isRevealed('synapse_password') ? 'text' : 'password'" formControlName="synapse_password" placeholder="••••••••" />
                    <button type="button" class="reveal-btn" (click)="toggleReveal('synapse_password')">
                      <i class="bi" [class.bi-eye]="!isRevealed('synapse_password')" [class.bi-eye-slash]="isRevealed('synapse_password')"></i>
                    </button>
                  </div>
                  @if (form.controls['synapse_password'].invalid && form.controls['synapse_password'].touched) {
                    <span class="field-error">Password is required.</span>
                  }
                </div>
              </div>
              <div class="form-group">
                <label for="synapse_driver">Driver</label>
                <input id="synapse_driver" type="text" formControlName="synapse_driver" placeholder="{ODBC Driver 17 for SQL Server}" />
                @if (form.controls['synapse_driver'].invalid && form.controls['synapse_driver'].touched) {
                  <span class="field-error">Driver is required.</span>
                }
              </div>
            </div>

            <div class="form-section optional">
              <h6 class="section-title">Write Access <span class="optional-tag">Optional</span></h6>
              <div class="form-row">
                <div class="form-group">
                  <label for="synapse_write_user">Write Username</label>
                  <input id="synapse_write_user" type="text" formControlName="synapse_write_user" placeholder="writeuser" />
                </div>
                <div class="form-group">
                  <label for="synapse_write_password">Write Password</label>
                  <div class="input-with-action">
                    <input id="synapse_write_password" [type]="isRevealed('synapse_write_password') ? 'text' : 'password'" formControlName="synapse_write_password" placeholder="••••••••" />
                    <button type="button" class="reveal-btn" (click)="toggleReveal('synapse_write_password')">
                      <i class="bi" [class.bi-eye]="!isRevealed('synapse_write_password')" [class.bi-eye-slash]="isRevealed('synapse_write_password')"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          }

          @case ('SNOWFLAKE') {
            <div class="form-section">
              <h6 class="section-title">Connection</h6>
              <div class="form-row">
                <div class="form-group">
                  <label for="account">Account</label>
                  <input id="account" type="text" formControlName="account" placeholder="xy12345.us-east-1" />
                  @if (form.controls['account'].invalid && form.controls['account'].touched) {
                    <span class="field-error">Account is required.</span>
                  }
                </div>
                <div class="form-group">
                  <label for="user">Username</label>
                  <input id="user" type="text" formControlName="user" placeholder="svc_user" />
                  @if (form.controls['user'].invalid && form.controls['user'].touched) {
                    <span class="field-error">Username is required.</span>
                  }
                </div>
              </div>
              <div class="form-row">
                <div class="form-group">
                  <label for="warehouse">Warehouse</label>
                  <input id="warehouse" type="text" formControlName="warehouse" placeholder="COMPUTE_WH" />
                  @if (form.controls['warehouse'].invalid && form.controls['warehouse'].touched) {
                    <span class="field-error">Warehouse is required.</span>
                  }
                </div>
                <div class="form-group">
                  <label for="private_key_path">Private Key Path</label>
                  <input id="private_key_path" type="text" formControlName="private_key_path" placeholder="/path/to/key.p8" />
                  @if (form.controls['private_key_path'].invalid && form.controls['private_key_path'].touched) {
                    <span class="field-error">Private key path is required.</span>
                  }
                </div>
              </div>
            </div>

            <div class="form-section optional">
              <h6 class="section-title">Write Access <span class="optional-tag">Optional</span></h6>
              <div class="form-row">
                <div class="form-group">
                  <label for="write_user">Write Username</label>
                  <input id="write_user" type="text" formControlName="write_user" placeholder="svc_write_user" />
                </div>
                <div class="form-group">
                  <label for="write_private_key_path">Write Private Key Path</label>
                  <input id="write_private_key_path" type="text" formControlName="write_private_key_path" placeholder="/path/to/write_key.p8" />
                </div>
              </div>
            </div>
          }

          @case ('DATABRICKS') {
            <div class="form-section">
              <h6 class="section-title">Connection</h6>
              <div class="form-row">
                <div class="form-group">
                  <label for="server_hostname">Server Hostname</label>
                  <input id="server_hostname" type="text" formControlName="server_hostname" placeholder="myworkspace.cloud.databricks.com" />
                  @if (form.controls['server_hostname'].invalid && form.controls['server_hostname'].touched) {
                    <span class="field-error">Server hostname is required.</span>
                  }
                </div>
                <div class="form-group">
                  <label for="http_path">HTTP Path</label>
                  <input id="http_path" type="text" formControlName="http_path" placeholder="/sql/1.0/warehouses/xxxx" />
                  @if (form.controls['http_path'].invalid && form.controls['http_path'].touched) {
                    <span class="field-error">HTTP path is required.</span>
                  }
                </div>
              </div>
              <div class="form-group">
                <label for="access_token">Access Token</label>
                <div class="input-with-action">
                  <input id="access_token" [type]="isRevealed('access_token') ? 'text' : 'password'" formControlName="access_token" placeholder="dapiXXXX" />
                  <button type="button" class="reveal-btn" (click)="toggleReveal('access_token')">
                    <i class="bi" [class.bi-eye]="!isRevealed('access_token')" [class.bi-eye-slash]="isRevealed('access_token')"></i>
                  </button>
                </div>
                @if (form.controls['access_token'].invalid && form.controls['access_token'].touched) {
                  <span class="field-error">Access token is required.</span>
                }
              </div>
              <div class="form-row">
                <div class="form-group">
                  <label for="catalog">Catalog</label>
                  <input id="catalog" type="text" formControlName="catalog" placeholder="main" />
                </div>
                <div class="form-group">
                  <label for="schema">Schema</label>
                  <input id="schema" type="text" formControlName="schema" placeholder="public" />
                </div>
              </div>
            </div>

            <div class="form-section optional">
              <h6 class="section-title">Write Access <span class="optional-tag">Optional</span></h6>
              <div class="form-group">
                <label for="write_access_token">Write Access Token</label>
                <div class="input-with-action">
                  <input id="write_access_token" [type]="isRevealed('write_access_token') ? 'text' : 'password'" formControlName="write_access_token" placeholder="dapiYYYY" />
                  <button type="button" class="reveal-btn" (click)="toggleReveal('write_access_token')">
                    <i class="bi" [class.bi-eye]="!isRevealed('write_access_token')" [class.bi-eye-slash]="isRevealed('write_access_token')"></i>
                  </button>
                </div>
              </div>
            </div>
          }
        }
      </form>
    }

  }

  <div footer class="footer-row">
    <button type="button" class="cancel-btn" [disabled]="saving" (click)="close()">Cancel</button>

    @if (step === 'form') {
      <button type="button" class="submit-btn" [disabled]="saving" (click)="submit()">
        @if (saving) {
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span>Saving…</span>
        } @else {
          <i class="bi bi-check-lg"></i>
          <span>{{ isEditing ? 'Save Changes' : 'Save Configuration' }}</span>
        }
      </button>
    }
  </div>
</app-modal-shell>
